const footerNav = [
  { label: '视频专区', href: '#media' },
  { label: '热度榜单', href: '#ranking' },
  { label: '热门吃瓜', href: '#cards' },
  { label: '平台特色', href: '#features' },
  { label: '焦点专题', href: '#carousel' },
  { label: '最新快讯', href: '#updates' },
  { label: '热门话题', href: '#topics' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
  { label: '主题索引', href: '#index' },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-300">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm font-heading">17</span>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">17吃瓜网</span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              17吃瓜网——你的在线吃瓜第一站。提供最新黑料吃瓜视频、爆料视频、
              网红视频在线观看，每日更新，一站看全。覆盖娱乐圈内幕、网红翻车、
              直播爆料等多元内容，为吃瓜爱好者打造真实快速的吃瓜视频平台。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-sm text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerNav.slice(0, 5).map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-sm text-background-100 mb-4">更多内容</h4>
            <ul className="space-y-2.5">
              {footerNav.slice(5).map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-sm text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="mt-4">
              <h4 className="font-medium text-sm text-background-100 mb-3">联系我们</h4>
              <a
                href="mailto:tougao@17chigua.com"
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer flex items-center gap-1"
              >
                <i className="ri-mail-line"></i> tougao@17chigua.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 17吃瓜网 - 17chigua.com . 本站内容仅供娱乐，请勿对号入座。
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
              免责声明
            </a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
              投稿爆料
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}